module.exports = __webpack_public_path__ + "img/new_logo.33fc2be4.png";